import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { ItemsTab, OverviewTab, ProfilePageTabId } from '@colonist/clientforge';
import { UIProfileLinkController } from './UIProfileLinkController.ts';
import { mountUIReactComponent } from '../ui_platform/mountUIReactComponent.tsx';
import { toOverviewBadges, toOverviewStats } from './overviewUtils.ts';
import { ClientUserState } from '../ClientUserState.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { toOwnedStoreItems } from './itemUtils.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
export class UIProfileController {
    refreshProfileForUsernameChange(newUsername) {
        this.username = newUsername;
        this.profileLinkController.setUsername(newUsername);
        this.profileLinkController.resetApiCalls();
        void this.makeApiCall();
        void this.getStickyPlayerInfo();
    }
    init() {
        const sectionFromHash = this.profileLinkController.showSectionFromHash();
        if (sectionFromHash == false) this.profileLinkController.showSection(ProfilePageTabId.Overview);
        void this.makeApiCall();
        void this.getStickyPlayerInfo();
    }
    onTabSelected(tabId) {
        this.profileLinkController.showSection(tabId);
        void this.makeApiCall();
    }
    setItems(items) {
        if (this.itemsView == undefined) this.itemsView = mountUIReactComponent('profile_items_div', ItemsTab);
        const onItemClick = UIUtilsEjsVariables.shouldHideStoreOnMobile ? undefined : (item)=>navigateToPage(`/store#${item.categorySlug}`);
        this.itemsView.render({
            items: toOwnedStoreItems(items),
            onItemClick: onItemClick
        });
    }
    async getStickyPlayerInfo() {
        var _ClientUserState_userState;
        const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiUserProfile.stickyPlayerInfo(this.username), undefined);
        if (response == undefined) {
            this.accountDoesNotExist();
            return;
        }
        const stickyPlayerInfo = response.json;
        const isOwnProfile = ClientUserState.userState != undefined && ClientUserState.userState.username == this.username;
        const icon = isOwnProfile ? (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.icon : stickyPlayerInfo.iconImageId;
        this.setUserIcon(icon);
        this.setMembershipIcon(stickyPlayerInfo.currentMembershipType);
        this.setStickyUsername(stickyPlayerInfo.username);
    }
    async makeApiCall() {
        switch(this.profileLinkController.activeTabId){
            case ProfilePageTabId.Overview:
                if (this.overviewView == undefined) {
                    this.overviewView = mountUIReactComponent('profile_overview_div', OverviewTab);
                    this.overviewView.render({
                        stats: undefined,
                        badges: undefined
                    });
                }
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Overview, UIAPIEndpoints.apiUserProfile.overview(this.username), (data)=>{
                    var _this_overviewView;
                    (_this_overviewView = this.overviewView) === null || _this_overviewView === void 0 ? void 0 : _this_overviewView.render({
                        stats: toOverviewStats(data),
                        badges: toOverviewBadges(data.userId)
                    });
                });
                break;
            case ProfilePageTabId.History:
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.History, UIAPIEndpoints.apiUserProfile.history(this.username), (data)=>{
                    this.setHistory(data);
                });
                break;
            case ProfilePageTabId.Items:
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Items, UIAPIEndpoints.apiUserProfile.items(this.username), (items)=>{
                    this.setItems(items);
                });
                break;
            case ProfilePageTabId.Ranked:
                // TODO: Fix this
                // this.rankedController = new UIProfileRankedController(this.username)
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Ranked, UIAPIEndpoints.apiUserProfileRankedSeasons(), (seasons)=>{
                    this.setRankedSeasons(seasons);
                });
                break;
            case ProfilePageTabId.Friends:
                break;
            case ProfilePageTabId.Settings:
                await this.profileLinkController.genericApiCallWrapper(ProfilePageTabId.Settings, UIAPIEndpoints.apiUserLoginState(), (userLogins)=>{
                    this.setProfileSettings(userLogins);
                });
                break;
            default:
                break;
        }
    }
    constructor(){
        var _ClientUserState_userState;
        this.profileLinkController = new UIProfileLinkController(false, '', (tabId)=>this.onTabSelected(tabId));
        ClientUserState.registerChangeListener(()=>{
            if (this.username == undefined) return;
            if (ClientUserState.userState == undefined) return;
            if (ClientUserState.userState.username != this.username) return;
            void this.getStickyPlayerInfo();
        });
        this.lastKnownUsername = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username;
        ClientUserState.registerChangeListener(()=>{
            var _ClientUserState_userState, _this_lastKnownUsername;
            const newUsername = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.username;
            if (newUsername == undefined) return;
            if (newUsername == this.lastKnownUsername) return;
            const wasViewingOwnProfile = this.username.toLowerCase() == ((_this_lastKnownUsername = this.lastKnownUsername) === null || _this_lastKnownUsername === void 0 ? void 0 : _this_lastKnownUsername.toLowerCase());
            this.lastKnownUsername = newUsername;
            if (!wasViewingOwnProfile) return;
            this.refreshProfileForUsernameChange(newUsername);
        });
    }
}
